exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".integrately-st0{\n  fill:transparent;\n  stroke:#FF6B01;\n  strokeWidth:4;\n  strokeMiterlimit:10;\n}\n.integrately-st2{fill:#FF6B01;}\n", ""]);
